import { colors } from '@shared/tokens/colors.stylex';
import { FC } from 'react';

interface ExclamationCircleIconProps {
  color?: string;
}

export const ExclamationCircleIcon: FC<ExclamationCircleIconProps> = ({ color = colors.errorText }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.875 10C1.875 5.51269 5.51269 1.875 10 1.875C14.4873 1.875 18.125 5.51269 18.125 10C18.125 14.4873 14.4873 18.125 10 18.125C5.51269 18.125 1.875 14.4873 1.875 10ZM10 6.875C10.3452 6.875 10.625 7.15482 10.625 7.5V10.625C10.625 10.9702 10.3452 11.25 10 11.25C9.65482 11.25 9.375 10.9702 9.375 10.625V7.5C9.375 7.15482 9.65482 6.875 10 6.875ZM10 13.75C10.3452 13.75 10.625 13.4702 10.625 13.125C10.625 12.7798 10.3452 12.5 10 12.5C9.65482 12.5 9.375 12.7798 9.375 13.125C9.375 13.4702 9.65482 13.75 10 13.75Z"
        fill={color}
      />
    </svg>
  );
};
